import React from "react";

import {
  Card,
  CardBody,
  Heading,
  Stack,
  CardFooter,
  Text,
  Divider,
  Image,
  Button,
  ButtonGroup,
  Grid,
  Center,
} from "@chakra-ui/react";

import styles from "../../styles/Project.module.css";
const Project = () => {
  return (
    <div id="projects">
      <div>
        <Heading
          textDecoration="underline"
          marginTop="50px"
          fontSize="45px"
          fontWeight="400"
          textAlign={"center"}
        >
          Project
        </Heading>
      </div>
      <Center>
        <div className={styles.project}>
          <Card maxW="sm" style={{ backgroundColor: "white" }} className='project-card'>
            <CardBody>
              <Image
                src={process.env.PUBLIC_URL + "/Images/anthropolgie.png"}
                alt="Green double couch with wooden legs"
                // borderRadius='lg'
              />
              <Stack mt="6" spacing="3" textAlign="center">
                <Heading size="md" className="project-title">Anthropologie Clone</Heading>
                <Text textAlign="justify" className="project-description">
                  At Terrain, we care about our environment and are committed to
                  helping protect our planet’s flora and fauna through our
                  partnerships with The Nature Conservancy and local
                  organizations focused on conservation and sustainability..
                </Text>
                <hr />
                <Text className="project-tech-stack">Html | CSS | React JS</Text>
              </Stack>
            </CardBody>
            <Divider />
            <CardFooter>
              <ButtonGroup
                spacing="2"
                display="flex"
                justifyContent="space-end"
              >
                <a
                className="project-github-link"
                  href="https://github.com/charchit07/joyous-clover-1589/tree/main/arthopologie"
                  target="_blank"
                >
                  <Button variant="solid" colorScheme="blue">
                    Github
                  </Button>
                </a>

                <a 
                className="project-deployed-link"
                  href="https://thunderous-jalebi-4d375c.netlify.app"
                  target="_blank"
                >
                  <Button variant="ghost" colorScheme="blue">
                    View
                  </Button>
                </a>
              </ButtonGroup>
            </CardFooter>
          </Card>
          <Card maxW="sm" style={{ backgroundColor: "white" }}  className='project-card'>
            <CardBody>
              <Image
                src={process.env.PUBLIC_URL + "/Images/coschedule.png"}
                borderRadius="lg"
                h={"55%"}
              />
              <Stack mt="6" spacing="2" textAlign="center">
                <Heading size="md" className="project-title">Coschedule Clone</Heading>
                <Text textAlign={"justify"} className="project-description">
                  At CoSchedule, we provide marketers with tools & training that
                  are uniquely helpful, fun to use, & consistently punch above
                  their weight.
                </Text>
                <hr />
                <Text className="project-tech-stack">Html | CSS | Javascript</Text>
              </Stack>
            </CardBody>
            <Divider />
            <CardFooter>
              <ButtonGroup spacing="2">
                <a
                className="project-github-link"
                  href="https://github.com/charchit07/-safe-drain-4510"
                  target="_blank"
                >
                  <Button variant="solid" colorScheme="blue">
                    Github
                  </Button>
                </a>
                <a 
                className="project-deployed-link"
                  href="https://fascinating-brigadeiros-d32345.netlify.app/"
                  target="_blank"
                >
                  <Button variant="ghost" colorScheme="blue">
                    View
                  </Button>
                </a>
              </ButtonGroup>
            </CardFooter>
          </Card>
          {/* Make My trip Clone (Musfair) */}
          <Card maxW="sm" style={{ backgroundColor: "white" }}  className='project-card'>
            <CardBody>
              <Center>
                <Image
                  src={process.env.PUBLIC_URL + "/Images/makemytrip.jpg"}
                  borderRadius="lg"
                  h={"55%"}
                />
              </Center>
              <Stack mt="6" spacing="2" textAlign="center">
                <Heading size="md" className="project-title">Musafir (Cloned MakeMytrip) </Heading>
                <Text textAlign={"justify"} className="project-description">
                  Musafir is a website for tours and travel created with one
                  thought that is to empower Indian traveler with instant
                  bookings and comprehensive choices.
                </Text>
                <hr />
                <Text className="project-tech-stack">React|Redux|Firebase|Axios|Material-UI</Text>
              </Stack>
            </CardBody>
            <Divider />
            <CardFooter>
              <ButtonGroup spacing="2">
                <a
                className="project-github-link"
                  href="https://github.com/hr927/wrong-touch-5488"
                  target="_blank"
                >
                  <Button variant="solid" colorScheme="blue">
                   
                  Github
                  </Button>
                </a>
                <a className="project-deployed-link" href="https://musafir-travel.netlify.app/" target="_blank">
                  <Button variant="ghost" colorScheme="blue">
                    View
                  </Button>
                </a>
              </ButtonGroup>
            </CardFooter>
          </Card>
          <Card maxW="sm" style={{ backgroundColor: "white" }}  className='project-card'>
            <CardBody>
              <Image
                src={process.env.PUBLIC_URL + "/Images/HomePage.png"}
                borderRadius="lg"
                h={"55%"}
              />
              <Stack mt="6" spacing="2" textAlign="center">
                <Heading size="md" className="project-title">Syntra (Cloned Myntra)</Heading>
                <Text textAlign={"justify"} className="project-description">
                  Syntra is a major Indian Fashion e-Commerce Company. Syntra
                  launched an express delivery service on its app to offer one
                  of a kind of experience by fashion & beauty platform.
                </Text>
                <hr />
                <Text className="project-tech-stack">
                  React JS | Redux | Axios| ChakraUI| NodeJS | Express |
                  MongoDB| Mongoose
                </Text>
              </Stack>
            </CardBody>
            <Divider />
            <CardFooter>
              <ButtonGroup spacing="2">
                <a
                className="project-github-link"
                  href="https://github.com/imukeshkaushal/Myntra-Clone"
                  target="_blank"
                >
                  <Button variant="solid" colorScheme="blue">
                    Github
                  </Button>
                </a>
                <a 
                className="project-deployed-link"
                  href="https://friendly-sorbet-912886.netlify.app/"
                  target="_blank"
                >
                  <Button variant="ghost" colorScheme="blue">
                    View
                  </Button>
                </a>
              </ButtonGroup>
            </CardFooter>
          </Card>
        </div>
      </Center>
    </div>
  );
};

export default Project;
